(function () {
    'use strict';

    function requestForProposalsController($scope) {
        var vm = this;
        vm.results = [];
        vm.entityId = '';

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.entityId = toParams.entityId;
        });

    }

    requestForProposalsController.$inject = ['$scope'];

    angular.module('ecap.crm').controller('requestForProposalsController', requestForProposalsController);
})();
